module.exports = __webpack_public_path__ + "images/binoculars-icon-a160ac9c.svg";